
<div class="tile-progress bg-white text-left col-lg-12">
  <div class="col-lg-6" style="padding-left: 0;">
    <label>Select account</label>
    <ng-select style="width: 64%;" [items]="accounts" name="accounts" bindLabel="accountName" (change)="getScreeningCenters();validateEyenukAccount(accountId)" [clearable]="true"
      [searchable]="true" bindValue="accountId" [(ngModel)]="accountId" placeholder="Select account">
    </ng-select>
  </div>
</div>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " *ngIf="accountId>0 && showEyeNukPanel" style="padding-left:0px;padding-right:0px">
  <div class="card-header">Generate Camera Token</div>
  <div class="content-body padding-top-20 padding-bottom-20">
  <table class="table table-borderless">
    <tr>
      <td><input type="text" [(ngModel)]="cameraId" placeholder="Enter camera id" class="form-control" required></td>
      <td><input type="text" [(ngModel)]="cameraCode" placeholder="Enter camera code" class="form-control" required></td>
      <td><button  class="col-xs-4 btn btn-primary pull-right" (click)="getCameraToken(cameraId,cameraCode)">Get Token</button></td>
    </tr>
  </table>
  <div *ngIf="camera_token!=null">
    <span style="font-weight: bold;">Camera Token : &nbsp;</span>
    <span *ngIf="camera_token=='loading'"><i class="fa fa-refresh fa-spin"></i> &nbsp; Fetching . . .</span>
    <span style="font-weight: bold;" *ngIf="camera_token!=null && camera_token!='loading'">{{camera_token}}</span>
    <br>
  </div>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " *ngIf="accountId>0" style="padding-left:0px;padding-right:0px;padding-top: 20px;">
    <div class="card-header">
      Provider configuration
      <button class="btn btn-sm btn-warning float-right" style="margin-top: -4px;background-color: rgb(87,200,231);" (click)="addNewRow()">
          <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add keys
        </button>
    </div>
    <div class="content-body padding-top-20 padding-bottom-20">
    <!--<table class="table table-bordered" >
      <tr><td>Subscription key</td><td><input type="text" class="form-control" [(ngModel)]="subscriptionKey" placeholder="Enter subscription key" required></td></tr>
    </table>-->
    <table class="table table table-borderless">
        <tr *ngFor="let itr of dataObject;let i=index">
          <td>
            <input [(ngModel)]="itr.key" type="text" class="form-control" required onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)"  
              placeholder="Enter key name" #keynameModel="ngModel" name="keyname"
              id="keynameModel" style="height:42px !important">
            <!--<div [hidden]="keyname.valid || keyname.pristine" class="danger-text">*Required</div>-->
          </td>
          <td>
            <input [(ngModel)]="itr.value" type="text" class="form-control" required placeholder="Enter value" onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)"  
              #valueModel="ngModel" name="value" id="value" style="height:42px !important">
           <!-- <div [hidden]="value.valid || value.pristine" class="danger-text">*Required</div>-->
          </td>
          <td>
              <!--<angular2-multiselect  [data]="screeningCenters" name="screeningCenters"
              #screeningCenterIds="ngModel" 
              [(ngModel)]="itr.screeningCenterIds" [settings]="dropdownSettings" >
            </angular2-multiselect>-->
              <ng-select [items]="screeningCenters" name="screeningCenters" bindLabel="orgName" [clearable]="true"
                [searchable]="true" bindValue="orgId" [(ngModel)]="itr.orgId" (change)="getExistingProviderByOrgId(itr)" placeholder="Select screening center">
              </ng-select>
          </td>
          <td >
            <ng-select *ngIf="itr.orgId>0" [items]="providers" name="providers" bindLabel="name" [clearable]="true" (change)="setProviderName(itr)"
              [searchable]="true" bindValue="id" [(ngModel)]="itr.serviceProviderId"  placeholder="Select service provider">
            </ng-select>
        </td>
          <td class="text-center">
            <i class="fa fa-trash" style="color:rgb(98,52,18);font-size:25px;cursor:pointer;" (click)="removeRow(i)"></i>
          </td>
        </tr>
      </table>
    <div class="text-center mTop15 modal-footer">
    <button class="btn btn-sm btn-success" (click)="save()"><i class="fa fa-check" style="margin: 5px;"></i>Save configuration</button>
    <button class="btn btn-sm" (click)="reset()" style="background-color: rgb(255,131,0);color:white"><i class="fa fa-fw fa-lg fa-undo" style="margin: 5px;"></i>Reset</button>
    </div>
</div>
</div>
